import React, {useEffect, useState} from 'react';
import CreateCourseUI from '../view/CreateCourseUI';
import {inject, observer} from 'mobx-react';
import {Subject} from '../../../../data/models/Course/LearningStandards';
import {CourseViewModel} from '../../../../data/models/Course/Course';
import {useNavigate, useParams} from 'react-router-dom';
import CreateCourseStore from '../store/CreateCourseStore';
import {useClarityPageView} from '../../../../utils/useClarityPageView';
import {clarityEvents} from '../../../../utils/clarityEvents';

interface Props {
  createCourseStore?: CreateCourseStore;
}

const CreateCourseContainer = inject('createCourseStore')(
  observer(({createCourseStore}: Props) => {
    const [subjects, setSubjects] = useState<Subject[]>([]);
    const {organizationId} = useParams();
    const navigate = useNavigate();

    useClarityPageView('/manage/home/create', 'staff');

    useEffect(() => {
      if (organizationId) {
        createCourseStore
          ?.getLearningStandarts(organizationId)
          .then(setSubjects);
      }
      return () => {
        clearErrors();
      };
    }, []);

    const createCourse = async (model: CourseViewModel, exit?: boolean) => {
      if (organizationId) {
        const createdCourse = await createCourseStore?.createCourse(
          {...model, organizationId},
          organizationId,
        );
        if (createdCourse && createdCourse.id) {
          clarityEvents.courseCreated(createdCourse.id);
          if (!exit) {
            navigate(
              `/editor/${organizationId}/courses/${createdCourse.id}/folders`,
            );
          } else {
            navigate(`/manage/${organizationId}/courses`, {replace: true});
          }
        }
      }
    };

    const onCancel = () => {
      navigate(`/manage/${organizationId}/courses`, {replace: true});
    };

    const clearErrors = () => {
      createCourseStore!.clearErrors();
    };

    return (
      <CreateCourseUI
        subjectOptions={subjects}
        createCourse={createCourse}
        onCancel={onCancel}
        errors={createCourseStore!.errors}
        clearErrors={clearErrors}
        isLoading={createCourseStore!.isLoading}
      />
    );
  }),
);

export default CreateCourseContainer;
